import importerStore from '@shared/importer/importer-store';
import { ParentService } from '@modules/parent/parent-service';
import parentImporterFields from '@modules/parent/parent-importer-fields';
import { i18n } from '@shared/i18n';

export default importerStore(
  ParentService.import,
  parentImporterFields,
  i18n('entities.parent.importer.fileName'),
  i18n('entities.parent.importer.hint'),
);
